export const LICENSE_STATUS = {
  ACTIVATED: 'activated',
  ASSIGNED: 'assigned',
  REVOKED: 'revoked',
  UNASSIGNED: 'unassigned',
};
